import ProductTags from '../../ProductTags'

import styles from './ProductCardLabelsList.module.scss'

interface ProductCardBadgesListProps {
  labels: string[]
}

const ProductCardLabelsList = ({ labels }: ProductCardBadgesListProps) => {
  return labels ? (
    <div className={styles.root}>
      {labels.map((label, index) => (
        <ProductTags key={`product-label-${index}`} name={label} />
      ))}
    </div>
  ) : null
}

export default ProductCardLabelsList
